import { render, staticRenderFns } from "./boxConfig.vue?vue&type=template&id=7dc7a182&scoped=true&"
import script from "./boxConfig.vue?vue&type=script&lang=js&"
export * from "./boxConfig.vue?vue&type=script&lang=js&"
import style0 from "./boxConfig.vue?vue&type=style&index=0&id=7dc7a182&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc7a182",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dc7a182')) {
      api.createRecord('7dc7a182', component.options)
    } else {
      api.reload('7dc7a182', component.options)
    }
    module.hot.accept("./boxConfig.vue?vue&type=template&id=7dc7a182&scoped=true&", function () {
      api.rerender('7dc7a182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/components/boxConfig.vue"
export default component.exports